export const getOpacity = (opacityValue: string): number => {
  return parseInt(opacityValue?.split?.('%')?.[0] || '100') / 100;
};
